module.exports = __webpack_public_path__ + "img/maze_circular_g.322eb3d8.svg";